import { Component } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-politica-cookies',
  templateUrl: './politica-cookies.component.html'
})
export class PoliticaCookiesComponent {
  constructor(private location: Location) {}
  return(){
    this.location.back();
  }
}
